import { TranslatePipe } from '../../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../../services/core-rest.service';
import AngularHelperService from '../../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'pre-visit-feedback',
	templateUrl: './pre-visit-feedback.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class PreVisitFeedbackComponentComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() preVisitTicketId: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isSaving = false;
		this.vm.ratingGiven = false;
		this.vm.commentGiven = false;
		this.vm.comment = '';
		this.vm.feedback = {
			preVisitTicket: {
				id: this.vm.preVisitTicketId
			}
		}
		
		this.vm.giveRating = this.giveRating;
		this.vm.sendComment = this.sendComment;
		this.vm.handleKeyup = this.handleKeyup;
	}
	
	giveRating(rating) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.vm.isSaving) {
			return;
		}
		this.vm.feedback = Object.assign(this.vm.feedback, { 'rating': rating })
		this.vm.isSaving = true;
		this.restService.savePreVisitFeedback(this.vm.feedback)
			.then((response) => {
				this.vm.feedback = response;
				this.vm.ratingGiven = true;
				this.vm.isSaving = false;
				deferred.resolve();
			})
			.catch((error) => {
				this.vm.isSaving = false;
				console.log(error);
			});
		return deferred.promise;
	}
	
	sendComment() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.vm.isSaving) {
			return;
		}
		this.vm.feedback = Object.assign(this.vm.feedback, { 'comment': this.vm.comment })
		this.vm.isSaving = true;
		this.restService.savePreVisitFeedback(this.vm.feedback)
			.then((response) => {
				this.vm.feedback = response;
				this.vm.commentGiven = true;
				this.vm.isSaving = false;
				deferred.resolve();
			})
			.catch((error) => {
				this.vm.isSaving = false;
				console.log(error);
			});
		return deferred.promise;
	}
	
	handleKeyup(event) {
		if (!event || this.vm.loading) {
			return;
		}
		if (event.key === "Enter" && this.vm.comment && this.vm.comment.length !== 0) {
			this.vm.sendComment();
		}
	}
	
}